// import { Menu } from 'react-admin'
export const MyMenu = () => (
	<div>
	</div>
)
